import { LaunchpoolStatus, LaunchpoolStatusType } from '@flipster/apis/v1/launchpool/types';
import { Badge } from '@flipster/react/design-system';

interface Props {
  status?: LaunchpoolStatusType;
}

const StakingStatusBadge = ({ status }: Props) => {
  if (status === LaunchpoolStatus.Upcoming)
    return (
      <Badge type='tint' color='accent'>
        Upcoming
      </Badge>
    );

  if (status === LaunchpoolStatus.Closed)
    return (
      <Badge type='tint' color='neutral'>
        Closed
      </Badge>
    );

  return (
    <Badge type='tint' color='positive'>
      Ongoing
    </Badge>
  );
};

export default StakingStatusBadge;
